import { Button } from '@cue/atoms';
import { useHash } from '@cue/hooks';
import { IVideoStateHandler } from '@cuevideostory/core';
import { CSSObject } from '@emotion/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PerfectScrollbar from 'react-perfect-scrollbar';

export const VirtualExperienceTopicsMenuItems = (props: VirtualExperienceTopicsMenuItemsProps) => {
  const { topics, onHideMenu, noScrollBar, containerRef, stateHandler } = props;

  const component = topics?.map((topic) => (
    <VirtualExperienceTopicsMenuItem
      stateHandler={stateHandler}
      topic={topic}
      key={topic.id}
      onHideMenu={onHideMenu}
    />
  ));
  const extraStyle: CSSObject = {};
  if (containerRef) {
    const height = containerRef.getBoundingClientRect().height;
    if (height) extraStyle.height = `${height - 88}px`;
  }

  return (
    <div
      className="cue-video-story-topics-menu-items"
      style={{ height: `${extraStyle.height || 'initial'}` }}>
      {noScrollBar ? component : <PerfectScrollbar>{component}</PerfectScrollbar>}
    </div>
  );
};

const VirtualExperienceTopicsMenuItem = (props: VirtualExperienceTopicsMenuItemProp) => {
  const { topic, onHideMenu, stateHandler } = props;
  const { state, setState } = stateHandler;

  const {
    i18n: { language },
  } = useTranslation();
  const { hash } = useHash();

  const [opened, setOpened] = useState(false);
  const [activeScene, setActiveScene] = useState(hash === topic?.video_app_scene);
  const clickHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    const nodeName = (event.target as HTMLElement).nodeName;
    const iconClicked = nodeName === 'svg' || nodeName === 'use';
    if (topic?.video_app_scene && (!iconClicked || !topic?.topics)) {
      setState(topic?.video_app_scene);
      onHideMenu && onHideMenu();
    } else {
      const t = topic?.topics;
      if ((t?.length || 0) > 0) {
        setOpened(!opened);
      }
    }
  };

  useEffect(() => {
    setActiveScene(state === topic?.video_app_scene);
  }, [state, topic?.video_app_scene]);

  useEffect(() => {
    if (activeScene) setOpened((topic?.topics?.length || 0) > 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeScene]);

  const translations = topic?.translations?.find((trans) => trans.language === language);
  return (
    <div className="cue-video-story-topics-menu-item">
      <Button
        className={`cue-video-story-topics-menu-item-button ${
          activeScene ? 'cue-video-story-topics-menu-item-button-active' : ''
        }`}
        onClick={clickHandler}
        icon={topic?.topics && opened ? 'arrowDown' : 'arrowRight'}
        iconAlign="right">
        {translations?.title}
      </Button>
      {topic?.topics && opened && (
        <VirtualExperienceTopicsMenuItems
          topics={topic?.topics}
          onHideMenu={onHideMenu}
          stateHandler={stateHandler}
          noScrollBar
        />
      )}
    </div>
  );
};

interface VirtualExperienceTopicsMenuItemsProps {
  topics?: VirtualExperienceTopic[];
  onHideMenu?(): void;
  stateHandler: IVideoStateHandler;
  noScrollBar?: boolean;
  containerRef?: HTMLDivElement | null;
}
interface VirtualExperienceTopicsMenuItemProp {
  topic: VirtualExperienceTopic;
  onHideMenu?(): void;
  stateHandler: IVideoStateHandler;
}
interface VirtualExperienceTopic {
  id: string;
  parent_topic: string;
  video_app_scene: string;
  translations: {
    language: string;
    title: string;
  }[];
  topics?: VirtualExperienceTopic[] | null;
}
